import React, { useEffect } from 'react';
import { Stack, Container } from '@fiverr-private/layout_components';
import { Typography, Text } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { Video } from '@fiverr-private/media';
import { getContext } from '@fiverr-private/fiverr_context';
import { Domingo } from '@fiverr-private/domingo';
import { AppI18n } from '../../../../../../shared/utils/i18n';
import { reportAiBannerShown, reportAiBannerClick } from './bqReports';
import { AI_BANNER_VIDEO_URL, AI_BANNER_POSTER_URL, AI_DIRECTOR_LINK_PATH, AI_DIRECTOR_UTM_SOURCE } from './constants';
import styles from './styles.module.scss';

const getCtaUrl = (): string => {
    const { url } = getContext();
    return `${Domingo(url).removePath().url}${AI_DIRECTOR_LINK_PATH}?utm_source=${AI_DIRECTOR_UTM_SOURCE}`;
};

export const AiBanner = () => {
    const ctaUrl = getCtaUrl();

    useEffect(() => {
        reportAiBannerShown();
    }, []);

    return (
        <Stack
            className={styles.banner}
            direction={{ default: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="spaceBetween"
            width="100%"
            height="auto"
        >
            <Stack
                direction="column"
                color="white"
                gap="0"
                width="100%"
                maxWidth={{ default: '100%', md: '285px', lg: '515px' }}
                flexShrink={0}
                order={{ default: 2, md: 1 }}
                paddingLeft={{ default: '5', md: '0' }}
                paddingRight={{ default: '5', md: '0' }}
            >
                <Stack direction="column" gap="4" marginBottom="6">
                    <Typography as="h2" color="inherit" className={styles.title}>
                        <AppI18n k="search_perseus.ai_banner.title" />
                    </Typography>
                    <Text color="inherit" className={styles.description}>
                        <AppI18n k="search_perseus.ai_banner.description" />
                    </Text>
                </Stack>
                <Stack direction="column" gap="4" width={{ default: '100%', sm: 'fit-content' }}>
                    <Button
                        href={ctaUrl}
                        size="lg"
                        fullWidth
                        variant="filled"
                        colorScheme="white"
                        onClick={reportAiBannerClick}
                        className={styles.ctaButton}
                    >
                        <AppI18n k="search_perseus.ai_banner.cta" />
                    </Button>
                </Stack>
            </Stack>
            <Container className={styles.mediaWrapper} order={{ default: 1, md: 2 }} flexGrow={1}>
                <Video
                    width="100%"
                    objectFit="contain"
                    autoPlay
                    playsInline
                    controls={false}
                    loop
                    muted
                    preload="auto"
                    poster={AI_BANNER_POSTER_URL}
                    aria-hidden
                    sources={[
                        {
                            src: AI_BANNER_VIDEO_URL,
                            type: 'video/mp4',
                        },
                    ]}
                />
            </Container>
        </Stack>
    );
};
